import { render, staticRenderFns } from "./SummaryIndex.vue?vue&type=template&id=2bb85896&scoped=true&"
import script from "./SummaryIndex.vue?vue&type=script&lang=js&"
export * from "./SummaryIndex.vue?vue&type=script&lang=js&"
import style0 from "./SummaryIndex.vue?vue&type=style&index=0&id=2bb85896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb85896",
  null
  
)

export default component.exports